/**
 * What the text says about each appointed time, in the text's own words.
 *
 * Keys are the feast names exactly as Torahly publishes them in `calendar_years`. KJV, because
 * it is public domain and the wording is the one this community reads aloud. Nothing here is a
 * paraphrase: the card quotes and cites, and leaves the reading to her.
 */

export interface FeastText {
  hebrew?: string
  cite: string
  quote: string
}

export const FEAST_TEXTS: Record<string, FeastText> = {
  Sabbath: {
    cite: 'Leviticus 23:3',
    quote:
      'Six days shall work be done: but the seventh day is the sabbath of rest, an holy convocation; ye shall do no work therein: it is the sabbath of the LORD in all your dwellings.',
  },
  Passover: {
    hebrew: 'Pesach',
    cite: 'Leviticus 23:5',
    quote: "In the fourteenth day of the first month at even is the LORD's passover.",
  },
  'Feast of Unleavened Bread': {
    hebrew: 'Matstsah',
    cite: 'Leviticus 23:6',
    quote:
      'And on the fifteenth day of the same month is the feast of unleavened bread unto the LORD: seven days ye must eat unleavened bread.',
  },
  'Feast of Weeks': {
    hebrew: 'Shabuwa',
    cite: 'Leviticus 23:16',
    quote:
      'Even unto the morrow after the seventh sabbath shall ye number fifty days; and ye shall offer a new meat offering unto the LORD.',
  },
  'Feast of Trumpets': {
    hebrew: 'Yom Teruah',
    cite: 'Leviticus 23:24',
    quote:
      'In the seventh month, in the first day of the month, shall ye have a sabbath, a memorial of blowing of trumpets, an holy convocation.',
  },
  'Day of Atonement': {
    hebrew: 'Yom Kippur',
    cite: 'Leviticus 23:27',
    quote:
      'Also on the tenth day of this seventh month there shall be a day of atonement: it shall be an holy convocation unto you; and ye shall afflict your souls, and offer an offering made by fire unto the LORD.',
  },
  'Feast of Tabernacles': {
    hebrew: 'Sukkoth',
    cite: 'Leviticus 23:34',
    quote:
      'Speak unto the children of Israel, saying, The fifteenth day of this seventh month shall be the feast of tabernacles for seven days unto the LORD.',
  },
  'Eighth Assembly': {
    hebrew: 'Shemini Atsereth',
    cite: 'Leviticus 23:36',
    quote:
      'On the eighth day shall be an holy convocation unto you; and ye shall offer an offering made by fire unto the LORD: it is a solemn assembly; and ye shall do no servile work therein.',
  },
}

export function feastText(name: string): FeastText | null {
  return FEAST_TEXTS[name] ?? null
}
